import React, { useEffect, useRef, useState } from "react"
import { IonHeader, IonToolbar, IonIcon, IonTitle, IonContent, IonCard, IonCardContent, IonItem, IonTextarea, IonLabel, IonButtons, IonButton, IonImg, IonText, IonPopover, useIonViewDidEnter, IonSpinner, IonProgressBar, IonToast, IonRouterLink, IonSlide, IonModal, IonBackdrop, IonRefresher, IonRefresherContent } from "@ionic/react"
import { arrowBack, camera, cameraSharp, image, imageSharp, imagesSharp, warning } from "ionicons/icons";
import { Plugins, CameraOptions, CameraResultType, CameraSource } from "@capacitor/core"
import "./GistModal.css"
import firebase from "firebase";
import { HapticVibrate } from "./MapModal";
 
const { Camera } = Plugins

export const cameraOption: CameraOptions =
{
    saveToGallery: true,
     presentationStyle: "fullscreen",
    resultType: CameraResultType.DataUrl,
    source: CameraSource.Camera,
    quality:60
}
export const galleryOption: CameraOptions =
{
     presentationStyle: "fullscreen",
    resultType: CameraResultType.DataUrl,
    source: CameraSource.Photos,
    quality:60

}
const CreateGist: React.FC <{openModal:boolean, closeModal:Function}> = ({openModal,closeModal}) => {
    const [images, setimages] = useState<any[]>([]);
    const [removeImage, setremoveImage] = useState(-1);
    const [userid, setuserid] = useState(``);
    const [user, setuser] = useState<any>({});
    const [posting, setposting] = useState(false);
    const [, setprogress] = useState(false);
     const [success, setsuccess] = useState(false);
    const backbutton = useRef(null), divRef=useRef<HTMLDivElement>(null);
    let pickerRef= useRef<HTMLInputElement>(null)
    const routerlink = useRef<HTMLIonRouterLinkElement>(null)
    const refreshRef=useRef<HTMLIonRefresherElement>(null)
     function pulltakeImage(){
             pickerRef.current?.click() 
             refreshRef.current?.complete()
     
     }

     function updateImages(){
       let files= pickerRef.current?.files
       let fr = new FileReader()
       if(files){
       fr.onload=()=>{
            setimages([...images,fr.result])
       }
     fr.readAsDataURL(files[0])
    }
        
     }
    const takeImage = async (option: CameraOptions) => {
      try{  const image = await Camera.getPhoto(option)
        setimages([...images, image.dataUrl + ""])
        }catch(err){
            alert(err)
        }
    }
    useEffect(() => {
        if(images.length>0){
             divRef.current?.scrollTo({behavior:`smooth`,top:1000*images.length})
        }
    }, [images]);
    useIonViewDidEnter(() => {
        // takeImage(cameraOption)
        Plugins.Storage.get({ key: `userid` }).then(res => setuserid(res.value + ``))
        Plugins.Storage.get({ key: `user` }).then(user => setuser(JSON.parse(user.value + ``)))
    })
    const cancelremove = () => {
        setremoveImage(-1)}
    const remove = () => {
        let imgs = images
        imgs.splice(removeImage, 1)
        setremoveImage(-1)
        setimages([...imgs])
    }

    const submit = async function (event: any) {
        console.log(user)
        event.preventDefault()
       
            let message = event.target.message.value
            let date = new Date()
            let dateString = (`${date.toDateString()}`)
            let date2 = Date.now()

            let gist = {
                userid: userid,
                message: message,
                date: dateString,
                date2: date2,

            }
          
            setposting(true)
            let SelectedImages=images.length>0?images:undefined
            closeModal({...gist,id:Math.random()+Date.now()+``,images:SelectedImages })
            setposting(false)
            setprogress(false)
             firebase.database().ref(`/gists`).child(user.faculty).push(gist).then((result) => {
                  
                if (result) {
                    let key = result.key
                   
                     let imageRefs = images.map((img, index) => {
                        return `gists/${user.faculty}/${key}/image${index}`
                    })
                    images.forEach((imgurl, index) => {
                        fetch(imgurl).then(async (res) => {
                            let blobimg = await res.blob()
                            firebase.storage().ref(imageRefs[index]).put(blobimg).then(async(res)=>{
                                setprogress(true)
                                
                            })
                        })
                    })
                   
                    if (key){
                        setimages([])
                        firebase.database().ref(`gists/${user.faculty}`).child(key + ``).set(JSON.stringify({ ...gist,images: imageRefs })).then((res) => {
                            setposting(false)
                            Plugins.Toast.show({text:`sending post`,duration:`short`,position:`center`}).then(()=>{
                               setimages([])
                              
                            })
                          
                        }).catch((err) => alert(err.message))

                        firebase.database().ref(`/gistIndex`).child(user.faculty).child(key).set(gist.userid)
                  }
                }
            })


        
    }
    return (
        <IonModal swipeToClose mode={`ios`} isOpen={openModal}  onDidDismiss={()=>{ closeModal()}}>
            <IonHeader mode={`md`}>
                <IonToolbar color="primary">
                    <IonButtons ref={backbutton} slot={`start`}>
                        <IonButton onClick={()=>HapticVibrate()}>
                            <IonBackdrop></IonBackdrop>
                            <IonIcon color={`light`} icon={arrowBack}></IonIcon>
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Create Gist</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonPopover isOpen={removeImage != -1} onDidDismiss={() => setremoveImage(-1)}>
                <img src={images[removeImage]} alt="" />
                <IonItem lines={`none`}>
                    <IonButton onClick={cancelremove} fill={`clear`}>cancel</IonButton>
                    <IonButtons slot={`end`}>
                        <IonButton onClick={remove} color={`danger`}>remove</IonButton>
                    </IonButtons>
                </IonItem>
            </IonPopover>
            <IonContent  >
                <IonRefresher  pullMin={180} ref={refreshRef} onIonRefresh={pulltakeImage} slot={`fixed`} >
                    <IonRefresherContent  pullingIcon={camera}  ></IonRefresherContent>
                </IonRefresher>
                <div className="ion-padding ion-margin">
                    <IonIcon icon={warning} color="warning"></IonIcon><IonText>gist created are only visible to members of your faculty</IonText>
                </div>
                <IonCard mode={`ios`}>
                 
                <IonCardContent>
                    <div ref={divRef} style={{overflowY: `scroll`,width:`100%`,height:`210px` }} >
                       
                       {
                            images.map((img, index) => <IonSlide  key={index}>
                                <IonImg onClick={() => setremoveImage(index)} alt="" src={img}></IonImg>
                            </IonSlide>)
                        }
                    </div>
                  
                        <form onSubmit={submit}>
                            <IonItem>
                                <IonLabel position="floating" >Enter Gist</IonLabel>
                                <IonTextarea disabled={posting} name={`message`} rows={2}></IonTextarea>
                            </IonItem>
                            <IonProgressBar color={`danger`} type={posting?`indeterminate`:`determinate`}  ></IonProgressBar>
                            <IonButtons className="ion-margin-top">
                                <IonButton disabled={posting} onClick={() => takeImage(cameraOption)} size="large">
                                    <IonIcon size="large" icon={cameraSharp}></IonIcon>
                                </IonButton>
                                <span className="ion-padding"> </span>
                                <IonButton disabled={posting} mode={`md`} onClick={() => takeImage(galleryOption)} size="large">
                                    <IonIcon size="large" icon={imageSharp}></IonIcon>
                                   
                                </IonButton>
                                <span className="ion-padding"> </span>
                                       <input accept="image/*"  type="file" onChange={updateImages} ref={pickerRef} hidden />
                              </IonButtons>

                            <div className="ion-padding ion-margin-top">
                                <IonButton disabled={posting} type={`submit`} expand="block" >
                                    {posting ? <IonSpinner paused={false} /> : `post`}
                                </IonButton>
                            </div>
                        </form>
                    </IonCardContent>

                </IonCard>
              </IonContent>
            <IonToast isOpen={success} duration={1400} onDidDismiss={() => setsuccess(false)} mode={`ios`} message={`successful`}></IonToast>
        </IonModal>
    )
}

export default CreateGist;


